import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { LibsModule } from 'src/app/libs/libs.module';
import { QRCodeModule } from 'angularx-qrcode';
import { AuthRoutingModule } from './auth-routing.module';

import { RegisterComponent } from '../register/register.component';
import { RegisterSuccessComponent } from '../register/register-success/register-success.component';
import { ActivateRegisterComponent } from '../register/activate-register/activate-register.component';
import { ModalRegisterSuccessComponent } from '../register/modal-register-success/modal-register-success.component';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { ModalExistingEmailComponent } from '../register/modal-alert-existing/modal-existing-email.component';

@NgModule({
  declarations: [
    RegisterComponent,
    RegisterSuccessComponent,
    ActivateRegisterComponent,
    ModalRegisterSuccessComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ModalExistingEmailComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AntDModule,
    LibsModule,
    QRCodeModule,
    AuthRoutingModule
  ],
  exports: [
    RegisterComponent,
    RegisterSuccessComponent,
    ActivateRegisterComponent,
    ModalRegisterSuccessComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ModalExistingEmailComponent
  ]
})
export class AuthModule { }
